export const FETCH_MEDIAS = "FETCH_MEDIAS";
